<template>
    <div class="report-item">
        <div class="left">
            <el-image @click="handlePreview" :src="item.coverUrl" alt=""/>
            <el-image class="img-icon" v-if="item.firstLevelType==='定制报告'||item.firstLevelType==='VIP专区'" :src="item.firstLevelType==='定制报告'?customizedImg:item.firstLevelType==='VIP专区'?vipImg:''"></el-image>
        </div>
        <div class="right">
            <div @click="handlePreview" class="title">{{ item.name }}</div>
            <span v-if="!notTip" class="type" v-for="citem in item.type.split(',')">{{ citem }}</span>
            <el-tooltip v-if="row<5"  effect="light">
                <template #default>
                    <div class="remark heights" :style="`-webkit-line-clamp: ${row}`" >{{item.remark}}</div>
                </template>
                <template  #content>
                    <div style="max-width: 200px;word-wrap: break-word" > {{item.remark}}</div>
                </template>
            </el-tooltip>

            <div v-else class="remark" :style="`-webkit-line-clamp: ${row}`" >{{item.remark}}</div>

            <el-button v-if="!notDownload" size="small" @click="handleDown" type="primary" plain round><i class="iconfont icon-xiazai"></i>下载
            </el-button>
            
            <!-- 取消这部分注释开放报告的收藏 -->
            <!-- <el-button v-if="item.college == 1" size="small" @click="sendDataToParent(item.id)" type="primary" class="btn" link text bg>
                <span class="concelCollegeImg"></span>
                取消收藏
            </el-button>
            <el-button v-if="colleges" size="small" @click="collegeReports(item.id, item.name, item.type)" type="primary" class="btn" link text bg>
                <span class="concelCollegeImg"></span>
                收藏
            </el-button>
            <el-button v-if="concel" @click="cancelReport(item.id)" type="primary" class="btn" link text bg>
                <span class="concelCollegeImg"></span>
                取消收藏
            </el-button>  -->
            
        </div>

    </div>
</template>

<script setup>
import vipImg from '@/assets/images/vip.png'
import customizedImg from '@/assets/images/customized.png'
import { ElMessage, ElMessageBox } from 'element-plus'
import { collegeReport, cancelReports } from "@/service/api";
import request from "@/service/request";
import {ref,onMounted} from "vue";

const props = defineProps({
    item: {
        type: Object,
        default: {}
    },
    type: {
        type: Number,
        default: 1
    },
    notDownload:{
        type:Boolean,
        default:false
    },

    notTip:{
        type:Boolean,
        default:false
    },
    row:{
        type:Number,
        default:3
    }
})
const emit = defineEmits(['cancelReport','getReportList']);
const concel = ref(false);
const colleges = ref(false);
const sendDataToParent = (e) => {
  emit('cancelReport', e);
};

const sendDataToParent2 = () => {
    console.log('33333');
    
  emit('getReportList');
};
const college = async (id, name, type) => {
    let data = await request({
        url: collegeReport,
        method: "post",
        data: {
            rptId: id,
            projectName: name,
            projectDeveloper: type

        }
    })
    console.log(data);
    
     if (data.data == 1) {
        colleges.value = false
        concel.value = true
        
        ElMessage({
            type: 'success',
            message: '收藏成功',
        })
    }
}
const collegeReports = (id, name, type) => {
    console.log(id);
    console.log(name);
    
    college(id, name, type)
}
const cancelReport = (value) => {
    console.log(value);
    ElMessageBox.confirm(
    '确定取消收藏该报告吗',
    '提示',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  )
    .then(() => {
        var s = deletereport(value)
        
        console.log('5555555555555555555');
        console.log(s);
        console.log('5555555555555555555');
        // getreportCollectList()
        concel.value = false
        colleges.value = true
      ElMessage({
        type: 'success',
        message: '取消成功',
      })
    })
}
const deletereport = async (e) => {
    console.log('6464646466646464');
    
    console.log(e);
    let { data } = await request({
        url: cancelReports,
        method: "post",
        data: {
            rptId: e
            
        }
    })
    getRep.value.projectName = ''
    sendDataToParent2()
}
const handleDown = () => {
    const link = document.createElement('a')
    //_blank表示在新窗口打开链接
    link.target = '_blank'
    link.href = props.item.pdfUrlDownload
    link.setAttribute('download', props.item.pdfFileName) // 下载文件的名称及文件类型后缀
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link) // 下载完成移除元素
}
// 预览
const handlePreview = () => {
    window.open(props.item.pdfUrl)
}
onMounted(() => {
console.log('212121');

    console.log(props.item);
    if (props.item.isCollege == 0) {
        console.log('456');
        
        colleges.value = true
        // concel.value = false
    } 
    if (props.item.isCollege == 1) {
        console.log('795');
        
        concel.value = true
        // colleges.value = false
    } 
    
})
</script>
<style lang="less" scoped>
.report-item {
    box-shadow: -4px 4px 23px 1px rgba(75,173,255,0.1);
    border-radius: 10px;
    display: flex;
    padding: 30px;
    box-sizing: border-box;
    cursor: pointer;
    border: 1px solid #fff;
    &:hover {
        border: 1px solid #0A9BFC;
        box-shadow: 0px 7px 13px 0px rgba(4, 0, 0, 0.1);
    }

    .left {
        width: 152px;
        height: 190px;
        background: #A0A0A0;
        flex-shrink: 0;
        position: relative;

        .img-icon {
            position: absolute;
            right: 0;
            top: 0;
            width: 38px;
            height: 20px;
        }
    }


    background: #fff;

    .right {
        margin-left: 28px;
        flex: 1;

        .title {
            height: 44px;
            font-size: 16px;
            font-weight: 400;
            color: #333333;
            line-height: 22px;
        }

        .type {
            display: inline-block;
            height: 26px;
            padding: 0 12px;
            border: 1px solid #5fc390;
            color: #5fc390;
            line-height: 26px;
            font-size: 12px;
            margin-top: 15px;
            margin-right: 5px;
            border-radius: 4px;
        }

        .remark {
            margin-top: 15px;
            font-size: 14px;
            font-weight: 400;
            color: #999999;
            line-height: 24px;
            overflow: hidden;
            width: 100%;
            text-overflow: ellipsis;
            display: -webkit-box;

            -webkit-box-orient: vertical;
        }

        .el-button {
            margin-top: 15px;
            background: #fff;
            color: #1477C9;
            border-color: #1477C9;
            font-size: 14px;
            font-weight: 400;

            & > .iconfont {
                font-size: 12px;
            }

            &:hover {
                background: #1477C9;
                color: #fff;
            }
        }
    }
}
.btn {
    // float: right;
    // font-size: 14px;
    border: 1px #ffdac1 solid;
    border-radius: 50px;
    padding: 2px 8px;
}

.report-item .right .btn:hover {
    background-color: #ffdac1;
}

.report-item .right .btn {
    border: 1px #ffdac1 solid;
}

.concelCollegeImg {
    display: inline-block;
    vertical-align: middle;
    width: 22px;
    height: 19px;
    background: url(../assets/images/concle.png);
    background-position: -4px -3px;
    background-size: 110%;
}
.heights {
    height: 48px;
}
</style>